import { render, staticRenderFns } from "./LeasingPrescoreRadioQuestion.vue?vue&type=template&id=cb29efba&scoped=true&"
import script from "./LeasingPrescoreRadioQuestion.vue?vue&type=script&lang=js&"
export * from "./LeasingPrescoreRadioQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LeasingPrescoreRadioQuestion.vue?vue&type=style&index=0&id=cb29efba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb29efba",
  null
  
)

export default component.exports